module.exports = __webpack_public_path__ + "d0a5b522b10fb175a00a9b8956ec3a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_download_2x.png
// module id = 33
// module chunks = 0 1 2 3 4